(function () {
  'use strict';

  if (window.cmNavigationBoundsBound) return;
  window.cmNavigationBoundsBound = true;

  var frame = 0;
  var menuSelector =
    '.site-nav__dropdown.standard-dropdown, .standard-dropdown .site-nav__subdropdown';

  function positionMenus() {
    frame = 0;

    var viewport = document.documentElement.clientWidth;
    var gap = 16;

    document.querySelectorAll('#AccessibleNav').forEach(function (nav) {
      var menus = Array.from(nav.querySelectorAll(menuSelector));

      nav.style.setProperty(
        '--cm-menu-max-width',
        Math.max(0, viewport - gap * 2) + 'px'
      );

      menus.forEach(function (menu) {
        menu.style.setProperty('--cm-menu-shift', '0px');
        menu.classList.remove('cm-menu-open-left');
      });

      if (viewport < 768 || !nav.getBoundingClientRect().width) return;

      menus.forEach(function (menu) {
        var rect = menu.getBoundingClientRect();

        if (!rect.width) return;

        if (
          menu.classList.contains('site-nav__subdropdown') &&
          rect.right > viewport - gap
        ) {
          var parent = menu.parentElement.getBoundingClientRect();

          if (parent.left - rect.width >= gap) {
            menu.classList.add('cm-menu-open-left');
            rect = menu.getBoundingClientRect();
          }
        }

        var shift = Math.min(0, viewport - gap - rect.right);
        shift = Math.max(shift, gap - rect.left);

        menu.style.setProperty('--cm-menu-shift', shift + 'px');
      });
    });
  }

  function schedule() {
    if (!frame) {
      frame = window.requestAnimationFrame(positionMenus);
    }
  }

  function refreshFromMenu(event) {
    if (
      event.target instanceof Element &&
      event.target.closest('#AccessibleNav')
    ) {
      schedule();
    }
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);

  document.addEventListener('pointerover', refreshFromMenu);
  document.addEventListener('focusin', refreshFromMenu);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener('loadingdone', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionMenus, {
      once: true
    });
  } else {
    positionMenus();
  }
})();